import React from 'react';
import { useRouter } from 'next/router';
import {
  NavigationTopBanner,
  Navigation,
  MenuSchemaEntry,
} from '@bucketplace/design-system';

import { useUserContext } from 'provider';

import { getQueryString, isInApp, handleOpenApp, handleLog, getNavigationProps } from 'utils';

import { SuperLink } from '../Link/SuperLink';

interface HeaderProps{
  navigationMenu: MenuSchemaEntry[];
  experiments?: Record<string, string>;
}

export const Header = ({
  navigationMenu,
  experiments,
}: HeaderProps): React.ReactElement => {
  const { userInfo, pcBanner, signOut } = useUserContext();
  const router = useRouter();
  const { pathname, query } = router;
  const search = `?${getQueryString(query)}`;

  const navigationProps = getNavigationProps({ navigationMenu, router, userInfo, signOut, experiments });

  return (
    <>
      { pcBanner && (
        <NavigationTopBanner
          location={{
            pathname,
            search,
          }}
          pcContentList={pcBanner}
          linkComponent={SuperLink}
          onAppOpen={handleOpenApp}
          onLog={handleLog}
          isUserLoggedIn={!!userInfo.user}
        />
      ) }
      { !isInApp() && (
        <Navigation
          {...navigationProps}
        />
      ) }
    </>
  );
};
